import * as Sentry from '@sentry/react'
import { getUserUuidFromLocalStorage } from '../utils'

const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN

export const initSentry = () => {
    if (SENTRY_DSN) {
        Sentry.init({
            dsn: SENTRY_DSN,
            release: __APP_VERSION__,
            attachStacktrace: true,
            enableLogs: true,
            integrations: [
                // send console.log, console.warn, and console.error calls as logs to Sentry
                Sentry.consoleLoggingIntegration({ levels: ['error', 'warn', 'trace'] })
            ],
            beforeSendLog(log) {
                //TODO: Fix these warnings
                const msg = log.message || ''

                // Expected operational condition, not a defect: the device gateway returns 504 when a
                // device request times out. Dropped here as well as at the call site so widening the
                // captured console levels can't reintroduce the noise.
                if (msg.includes('device unreachable')) {
                    return null
                }

                if (
                    msg.includes('atomic rendering') ||
                    msg.includes('styled component') ||
                    msg.includes('withStyle') ||
                    msg.includes('withTransform') ||
                    msg.includes(' https://go.apollo.dev') ||
                    msg.includes('A history supports') ||
                    msg.includes('styleOverrides') ||
                    msg.includes('scalar.field') ||
                    msg.includes('<Router history>')
                ) {
                    return null // Drop this log
                }

                const userUuid = getUserUuidFromLocalStorage()
                log.message = log.message.toLowerCase()
                log.message += ' by user ' + userUuid

                return log
            }
        })
    }
}
